import React, { useId, useMemo } from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: readonly string[];
  className?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  listId?: string;
};

export const CityCombobox: React.FC<Props> = ({
  value,
  onChange,
  options,
  className = "eventos-input",
  required,
  disabled,
  placeholder = "Type or select city",
  listId,
}) => {
  const autoId = useId();
  const datalistId = listId ?? `city-list-${autoId.replace(/:/g, "")}`;

  const sortedOptions = useMemo(() => {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const option of options) {
      const key = option.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        out.push(option);
      }
    }
    return out.sort((a, b) => a.localeCompare(b));
  }, [options]);

  return (
    <>
      <input
        className={className}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        list={datalistId}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete="address-level2"
      />
      <datalist id={datalistId}>
        {sortedOptions.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
    </>
  );
};
